import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import {
  NewsletterState,
  NewsletterType,
} from 'b2b-apps/shop/newsletter/redux/types';

const getState = (state: State): NewsletterState => state.newsletter;

const getSubscription = (state: State): RemoteRecord<NewsletterType> => new RemoteRecord(getState(state));

export { getState, getSubscription };
